module.exports = __webpack_public_path__ + "static/how-to-1-9bb1d4fb1b37f840c00be2fbbedd1f38.webp";